/**
 * Chart palette. Brand tokens by value, not by Tailwind class — D3 writes
 * these into SVG attributes, where a class name means nothing.
 */
export const COLORS = {
  beat: '#1c76a2', // Up / Call — actual met or cleared consensus
  miss: '#d8483b', // Down / Put — actual came in short
  estimate: '#c7c2b8', // Text Muted — the consensus reference line
  surface: '#161616', // Chart Well — rings and gaps punch back to this
  grid: 'rgba(255,255,255,0.05)',
  axis: '#2b2b2b',
  text: '#c7c2b8',
  upcoming: '#c2a14e', // Accent Gold — the scheduled report marker
  // Quarters with no consensus to judge against. Deliberately dimmer than
  // the verdict colours: an unknown should recede, not dominate.
  unknown: '#4a4843',
} as const;

/** Plot area insets. Left carries the value axis, bottom the quarter labels. */
export const MARGINS = { top: 12, right: 12, bottom: 26, left: 52 } as const;

/** Panel height in CSS pixels, chosen so both panels and the table fit a screen. */
export const PANEL_HEIGHT = 190;

/** History windows offered by the range toggle. Null keeps every quarter. */
export const RANGES: { key: string; label: string; quarters: number | null }[] = [
  { key: '2y', label: '2Y', quarters: 8 },
  { key: '3y', label: '3Y', quarters: 12 },
  { key: '5y', label: '5Y', quarters: 20 },
  { key: 'all', label: 'All', quarters: null },
];

export const DEFAULT_RANGE = '3y';
